import type { CallbackInterface } from 'recoil'

import { notifySaveSuccess } from 'Pages/RecipientsList/recoil/services/modalSaveSegment'
import { modalSaveSegmentState } from 'Pages/RecipientsList/recoil/state/modals'

export const modalSaveSegmentOpenCallback =
  ({ set }: CallbackInterface) =>
  async () => {
    set(modalSaveSegmentState, (prev) => ({
      ...prev,
      show: true,
    }))
  }

export const modalSaveSegmentCancelCallback =
  ({ reset }: CallbackInterface) =>
  async () => {
    reset(modalSaveSegmentState)
  }

export const modalSaveSegmentChangeCallback =
  ({ set }: CallbackInterface) =>
  async (name: string) => {
    set(modalSaveSegmentState, (prev) => ({
      ...prev,
      name,
      nameIsDirty: true,
    }))
  }

export const modalSaveSegmentConfirmCallback =
  ({ reset }: CallbackInterface) =>
  async () => {
    reset(modalSaveSegmentState)

    notifySaveSuccess()
  }
